import { produce } from 'immer';

import {
  CLEAR_SELECT_ALL_FUNNELS,
  CREATE_STAGE_FILTER_SUCCESS,
  DELETE_STAGE_FILTER_SUCCESS,
  FETCH_STAGE_FILTERS_SUCCESS,
  FUNNELS_SEARCH_COMPLETE,
  FUNNELS_SEARCH_INIT,
  LOAD_MORE_FUNNELS,
  LOAD_MORE_FUNNELS_ERROR,
  SELECT_ALL_FUNNELS_ERROR,
  SELECT_ALL_FUNNELS_INIT,
  SELECT_ALL_FUNNELS_SUCCESS,
  SET_SELECTED_FILTER,
  SET_SELECTED_JOBS_DATA,
  UPDATE_FUNNELS_SEARCH,
  UPDATE_STAGE_FILTER_SUCCESS,
} from './constants';

export const initialState = {
  stageFilters: [],
  selectedFilter: null,
  search: '',
  activeOnly: false,
  isFetchingFunnels: false,
  isLoadingMoreFunnels: false,
  isSelectingAllFunnels: false,
  jobsData: [],
  selectedJobsData: [],
  pagination: null,
  selectAllSelection: null,
  funnelSearchEpoch: 0,
  selectAllRequestId: 0,
};

const sortFilters = (a, b) => a.title.localeCompare(b.title);

const jobsStagesFilterPopupReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FETCH_STAGE_FILTERS_SUCCESS:
        draft.stageFilters = action.stageFilters;
        draft.stageFilters.sort(sortFilters);
        break;
      case UPDATE_STAGE_FILTER_SUCCESS: {
        draft.selectedFilter = action.stageFilter;
        draft.stageFilters = draft.stageFilters.map(stageFilter => {
          if (stageFilter.id === action.stageFilter.id)
            return action.stageFilter;
          return stageFilter;
        });
        draft.stageFilters.sort(sortFilters);
        break;
      }
      case CREATE_STAGE_FILTER_SUCCESS:
        draft.selectedFilter = action.stageFilter;
        draft.stageFilters.push(action.stageFilter);
        draft.stageFilters.sort(sortFilters);
        break;
      case DELETE_STAGE_FILTER_SUCCESS: {
        draft.selectedFilter = null;
        draft.stageFilters = draft.stageFilters.filter(
          stageFilter => stageFilter.id !== action.filterId,
        );
        break;
      }
      case SET_SELECTED_FILTER:
        draft.selectedFilter = action.selectedFilter;
        break;
      case UPDATE_FUNNELS_SEARCH:
        draft.search = action.search;
        draft.activeOnly = action.activeOnly;
        // Also bumped here, not just in FUNNELS_SEARCH_INIT. The search saga
        // is debounced 500ms, but searchInput updates immediately. A load-more
        // fired in that window would otherwise keep the pre-keystroke epoch.
        draft.funnelSearchEpoch += 1;
        // The epoch bump alone doesn't block a load-more fired in the same
        // window: it would carry the new epoch (nothing has bumped it since)
        // and the stale next_page from the filter that's being replaced.
        // Clearing pagination makes onLoadMoreFunnels see no next_page to load.
        draft.pagination = null;
        break;
      case FUNNELS_SEARCH_INIT:
        draft.isFetchingFunnels = true;
        draft.funnelSearchEpoch += 1;
        draft.isLoadingMoreFunnels = false;
        break;
      case LOAD_MORE_FUNNELS:
        draft.isLoadingMoreFunnels = true;
        break;
      case LOAD_MORE_FUNNELS_ERROR:
        if (action.epoch !== draft.funnelSearchEpoch) break;
        draft.isLoadingMoreFunnels = false;
        break;
      case FUNNELS_SEARCH_COMPLETE:
        if (action.epoch !== draft.funnelSearchEpoch) {
          draft.isLoadingMoreFunnels = false;
          break;
        }
        draft.jobsData =
          action.page > 1
            ? [...draft.jobsData, ...(action.jobsData || [])]
            : action.jobsData;
        draft.pagination = action.pagination;
        draft.isFetchingFunnels = false;
        draft.isLoadingMoreFunnels = false;
        break;
      case SET_SELECTED_JOBS_DATA:
        draft.selectedJobsData = action.selectedJobsData;
        break;
      case SELECT_ALL_FUNNELS_INIT:
        draft.isSelectingAllFunnels = true;
        draft.selectAllRequestId += 1;
        break;
      case SELECT_ALL_FUNNELS_SUCCESS:
        draft.isSelectingAllFunnels = false;
        // Compare against the filter itself, not funnelSearchEpoch: that epoch
        // also bumps on an unrelated debounced refresh that resolves to the
        // same filter, which would needlessly discard a still-valid response.
        // requestId also has to match — it bumps when the popup closes, so a
        // response that resolves after close-and-reopen can't apply to the
        // new session even if search/activeOnly happen to match again.
        if (
          action.requestId === draft.selectAllRequestId &&
          action.search === draft.search &&
          action.activeOnly === draft.activeOnly
        ) {
          draft.selectAllSelection = action.selectAllSelection;
        }
        break;
      case SELECT_ALL_FUNNELS_ERROR:
        draft.isSelectingAllFunnels = false;
        break;
      case CLEAR_SELECT_ALL_FUNNELS:
        draft.selectAllSelection = null;
        draft.isSelectingAllFunnels = false;
        draft.selectAllRequestId += 1;
        break;
      // no default
    }
  });

export default jobsStagesFilterPopupReducer;
